// extracted by mini-css-extract-plugin
export default {"container":"Cq-z","heading":"Dq-z","text":"Eq-z","info":"Fq-z","link":"Gq-z","fullMaxWidth":"Hq-z"};